export default __webpack_public_path__ + "static/media/redeemWhiteMode.e8e66677.svg";